import React from 'react';
import { MessageContentWrapper } from './MessageContentWrapper';

export const SuggestionsDisplay = ({ suggestions }: { suggestions: string[] }) => {
    return (
        <MessageContentWrapper>
            <div className='caption-1-bold text-gray mb-3'>Suggestions:</div>
            <div className='space-y-2'>
                {suggestions.map((suggestion, index) => (
                    <div key={index} className='border-subtle bg-neutral-subtle rounded-lg border p-3 shadow-sm'>
                        <p className='caption-1-regular text-gray'>{suggestion}</p>
                    </div>
                ))}
            </div>
        </MessageContentWrapper>
    );
};
